import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeeSalaries: [],
    employeeSalariesCount: 0,
    employeeSalary: {},
    employeeSalarySave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeeSalaries(state) {
      return state.employeeSalaries
    },
    getEmployeeSalariesCount(state) {
      return state.employeeSalariesCount
    },
    getEmployeeSalary(state) {
      return state.employeeSalary
    },
    getEmployeeSalarySaveStatus(state) {
      return state.employeeSalarySave
    },
  },
  mutations: {
    EMPLOYEE_SALARIES_LIST(state, data) {
      state.employeeSalaries = data
    },
    EMPLOYEE_SALARY_VIEW(state, data) {
      state.employeeSalary = data
    },
    EMPLOYEE_SALARIES_COUNT(state, data) {
      state.employeeSalariesCount = data
    },
    EMPLOYEE_SALARY_SAVE(state, data) {
      state.employeeSalarySave = data
    },
  },
  actions: {
    employeeSalariesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_salary', data)
        .then(response => {
          commit('EMPLOYEE_SALARIES_LIST', response.data.data)
          commit('EMPLOYEE_SALARIES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeSalaryView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_salary.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_salary', data)
        .then(response => {
          commit('EMPLOYEE_SALARY_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeSalarySave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_salary/saveData', data)
        .then(response => {
          commit('EMPLOYEE_SALARY_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
